import React from 'react';
import PropTypes from 'prop-types';
import LikeButton from './LikeButton';
import LikeCounter from './LikeCounter';
import LogInOrSignUpMenu from './LogInOrSignUpMenu';

export default class LikeButtonContainer extends React.Component {
    likeButton() {
        if (this.props.design.permission.canLike) {
            return (
                <LikeButton
                    design={this.props.design}
                    csrfToken={window.REQUEST_TOKENS.DESIGN_UPDATE_LIKE_STATUS} // FIXME: embed in url
                />
            );
        }
        return <LogInOrSignUpMenu design={this.props.design} />;
    }

    render() {
        return (
            <span data-like-button data-liked={this.props.design.likedByUser}>
                { this.likeButton() }
                <LikeCounter design={this.props.design} />
            </span>
        );
    }
}

LikeButtonContainer.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/components/LikeButtonContainer.jsx